<div class="main-content">
    <div class="half-top"></div>
    <div *ngIf="!utility?.isMobileDevice()" class="company-logo"
        (click)="redirectToCompanyWebiste()"></div>
    <router-outlet></router-outlet>
</div>

<app-footer></app-footer>